'use strict';

import $ from 'jquery';
import mediator from '../../js/mediator';
import config from '../../js/config';
import PromotionalGiveawayModal from './PromotionalGiveawayModal';
import cookies from 'js-cookie';

export default class PromotionalGiveawayTrivia {
  constructor($el) {
    this.$el = $el;
    this.initialize();
  }
  initialize() {
    this.initialzeElements();
    this.previewFile();
    this.showAnswers();
    if (this.$videoTrivia.length) {
      this.renderVideoTrivia();
      this.triviaUserResponseList = [];
    }
    if (this.photoUploadResponse) {
      this.onSubmitSuccess();
    }
  }

  initialzeElements() {
    this.photoUploadResponse = this.$el.find('.PromotionalGiveaway-photoUpload').data('photoUploadResponse');
    this.$previewFile = this.$el.find('.PromotionalGiveaway-photoUpload-file-selector');
    this.$videoTrivia = this.$el.find('.PromotionalGiveaway-videoTrivia');
    this.videoTriviaEl = this.$el.find('.PromotionalGiveaway-videoTrivia .Content');
    this.startingTime = Date.now();
    this.videoTriviaData = this.videoTriviaEl.data('videoTriviaInfo');
  }

  initializeVideoElements() {
    this.$videoQuestions = this.$el.find('.PromotionalGiveaway-videoTrivia-form');
    this.$videoButtonNext = this.$el.find('.PromotionalGiveaway-videoTrivia-button--next');
    this.$videoButtonSubmit = this.$el.find('.PromotionalGiveaway-videoTrivia-button--submit');
    this.$videoButtonSubmitTrivia = this.$el.find('.PromotionalGiveaway-videoTrivia-button--submit');
    this.$videoQuestionInstructions = this.$el.find('.PromotionalGiveaway-videoTrivia-form--instructions');
    this.videoQuestionGUID = this.$el.find('.PromotionalGiveaway-question').data('triviaItemid');
    this.$videoButtonNext.click((event) => {this.renderVideoTrivia(event)});
    this.$videoButtonSubmit.click(() => {this.updateTriviaResponseList()});
  }

  renderVideoTrivia(nextClicked) {
    // retrieve GUID list
    this.videoList = this.videoTriviaData.VideoTriviaQuestionandAnswersGuidList;
    let videosAvailableInCurrentQuiz  = this.videoTriviaData.VideosAvailableInCurrentQuiz;
    let currentQuestionIndex = videosAvailableInCurrentQuiz - this.videoList.length + 1;
    if (nextClicked) {
      nextClicked.preventDefault();
      this.updateTriviaResponseList();
    }

    if (this.videoList.length) {
      let firstVideoItem = this.videoList.shift();
      this.requestVideoData(firstVideoItem, currentQuestionIndex).done(res => {
        this.videoTriviaEl.html(res);
        this.initializeVideoElements();
        this.$videoButtonNext.text(this.videoTriviaEl.data('videoTriviaInfo').CtaText1);
        if (this.videoList.length === 0) {
          this.$videoButtonSubmitTrivia.attr('value', this.videoTriviaEl.data('videoTriviaInfo').CtaText2);
          this.$videoButtonSubmitTrivia.addClass(config.classes.isActive);
          this.$videoButtonNext.removeClass(config.classes.isActive);
        }
        mediator.trigger(config.events.ui.ajaxContentLoaded, this.$el);
      });
    }
  }

  updateTriviaResponseList() {
    let triviaUserAnswers = {};
    let videoTriviaData = {};
    triviaUserAnswers.QuestionItemId = this.videoQuestionGUID;
    triviaUserAnswers.UserAnswerChoice = $('.PromotionalGiveaway-videoTrivia-form input[type=radio]:checked').val();
    this.triviaUserResponseList.push(triviaUserAnswers);

    if (this.videoList.length === 0) {
      videoTriviaData = {
        triviaLandingItemId: this.videoTriviaEl.data('videoTriviaInfo').VideoTriviaLandingItemId,
        userPromoRegestrationGuid: cookies.get('PromotionalGiveawayGUID'),
        isVideoTrivia: true,
        isEngineeringQuiz: false,
        triviaActionType: this.videoTriviaEl.data('videoTriviaInfo').VideoTriviaActionType,
        triviaUserResponseList: this.triviaUserResponseList,
        completionTime: this.timeCompleted(Date.now())
      }
      this.postAnswers(JSON.stringify(videoTriviaData));
    }
  }

  requestVideoData(guid ,currentQuestionIndex) {
    let url = config.promoGiveaway.videoTriviaUrl + guid;
    url = `${url}&currentQuestionIndex=${currentQuestionIndex}`;
    return $.ajax({
      dataType: 'html',
      method: 'GET',
      url
    });
  }

  timeCompleted(finishTime) {
    let timeCompleted = finishTime - this.startingTime;
    let minutes = Math.floor(timeCompleted / 60000);
    let seconds = ((timeCompleted % 60000) / 1000).toFixed(0);
    return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
  }

  postAnswers(triviaData) {
    $.ajax(config.promoGiveaway.videoTriviaPostUrl, {
      contentType: 'application/json',
      method: 'POST',
      data: triviaData
    })
      .done(triviaResponse => {
        this.onSubmitSuccess(triviaResponse);
      })
      .fail(() => {this.onSubmitFailed(); });
  }

  onSubmitSuccess() {
    let modal = new PromotionalGiveawayModal();
    if (this.photoUploadResponse) {
      modal.open({
        title: this.photoUploadResponse.ActionCompleteTitleText,
        message: this.photoUploadResponse.ActionCompleteDescription,
        cta1Link: this.photoUploadResponse.ReturntoCta1Url,
        cta1Text: this.photoUploadResponse.ReturntoCta1Text,
        cta2Link: this.photoUploadResponse.ReturnToCta2Url,
        cta2Text: this.photoUploadResponse.ReturnToCta2Text
      });
    }
    else {
      modal.open({
        title: this.videoTriviaData.ActionCompleteTitleText,
        message: this.videoTriviaData.ActionCompleteDescription,
        cta1Link: this.videoTriviaData.ReturntoCta1Url,
        cta1Text: this.videoTriviaData.ReturntoCta1Text,
        cta2Link: this.videoTriviaData.ReturnToCta2Url,
        cta2Text: this.videoTriviaData.ReturnToCta2Text
      });
    }
  }

  onSubmitFailed() {
    let modal = new PromotionalGiveawayModal();
    modal.open({
      title: 'Duh oh',
      message: 'Network error, try again'
    });
  }

  showAnswers() {
    mediator.on(config.events.youtubePlayer.done, () => {
      this.$videoQuestions.addClass(config.classes.isActive);
      this.$videoQuestionInstructions.removeClass(config.classes.isActive);
    });
  }

  previewFile() {
    this.$previewFile.change((e) => {
      let files = e.currentTarget.files;
      if (files && files[0] && this.isAcceptableImageType(files[0]) && this.isAcceptableImageSize(files[0])) {
        let reader = new FileReader();
        let imageName = $('.PromotionalGiveaway-photoUpload-file-name');

        reader.onload = function(e) {
          let $imagePreview = $('.PromotionalGiveaway-photoUpload-preview-photo');
          let $photoControls = $('.PromotionalGiveaway-photoUpload-preview');
          $imagePreview.attr('src',e.target.result);
          $photoControls.addClass(config.classes.isActive);
        }

        reader.readAsDataURL(files[0]);
        imageName.attr('placeholder', files[0].name);
      }
      else {
        alert('Please select an acceptable image type or select a smaller image');
      }
    });
  }

  isAcceptableImageType(file) {
    let fileExtention = file.type.split('/')[1];
    switch (fileExtention) {
      case config.imageTypes.png:
        return true;
      case config.imageTypes.jpeg:
        return true;
      case config.imageTypes.gif:
        return true;
      case config.imageTypes.jpg:
        return true;
      default:
        return false;
    }
  }

  isAcceptableImageSize(file) {
    let fileSizeBytes = file.size;
    // If file is greater than 5MB
    return fileSizeBytes > 5000000 ? false : true;
  }
}



// WEBPACK FOOTER //
// ./assets/components/PromotionalGiveaway/PromotionalGiveawayTrivia.js